import React, { useEffect, useState } from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useNavigate } from '@thd-olt-component-react/router';
import useQuery from '../../utils/useQuery';

const GoBackNavLink = ({ backToStr, fallbackUrl }) => {
  const query = useQuery();
  const [goBack, updateGoBack] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    updateGoBack(query.get('goBack'));
  }, []);

  if (!goBack && !fallbackUrl) {
    return null;
  }

  return (
    <>
      <div
        className="my-dashboard__back"
        onClick={() => navigate(goBack || fallbackUrl)}
      >
        <ArrowBackIosIcon className="my-dashboard__back-icon" />
        <span className="my-dashboard__back-content">Back to {backToStr}</span>
      </div>
    </>
  );
};

export default GoBackNavLink;
